// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { Col, Row, ButtonGroup } from 'react-bootstrap';
import { css } from 'glamor';

import Title from '~/components/global/Title';
import ReviewList from '~/components/content/review/ReviewList';
import FacebookShareButton from '~/components/global/FacebookShareButton';
import TwitterShareButton from '~/components/global/TwitterShareButton';
import type { Review as ReviewType } from '~/types';

const section = css({
    textAlign: 'center',
    height: '50px',
    fontSize: '0.9em',
    textTransform: 'uppercase',
    fontWeight: 600,
    borderRadius: 0,
    lineHeight: '50px',

    transition: 'all 0.5s ease',

    backgroundColor: 'rgb(228, 65, 34)',
    color: '#fff',
});

const shareButton = css({
    float: 'right',
    margin: '10px',
    marginTop: 0,
    marginRight: 0,
});

@observer
export default class Home extends React.Component {
    props: {
        latestReviews: Array<ReviewType>,
        topReviews: Array<ReviewType>,
    };

    render() {
        return (
            <div>
                <div>
                    <FacebookShareButton { ...shareButton } />
                    <TwitterShareButton { ...shareButton } />
                </div>
                <Row>
                    <Col md={ 8 }>
                        <h4>
                            <Title boldText="LATEST" normalText=" REVIEWS" />
                        </h4>
                        <ReviewList
                            reviews={ this.props.latestReviews }
                            summary="semi"
                        />
                    </Col>

                    <Col md={ 4 }>
                        {/* TODO replace this by section navigation */}
                        <ButtonGroup justified>
                            <div { ...section }>
                                {'TOP RATED'}
                            </div>
                        </ButtonGroup>

                        <ReviewList
                            reviews={ this.props.topReviews }
                            summary="short"
                        />

                    </Col>
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/Home.js